export default __webpack_public_path__ + "static/media/Apple iPad Mini (2019).9fc3f8e9.png";